import { yup } from '@lon/shared/utils';

export const VALIDATION_SCHEMA = yup.object().shape({
  studentIds: yup.object().shape({}),
});
